namespace RedBullMOBILE360.AutomaticReports {
    export interface ReportLogRow {
        Id?: number;
        ReportId?: number;
        Recipients?: string;
        SendingDate?: string;
        Status?: number;
    }

    export namespace ReportLogRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Recipients';
        export const localTextPrefix = 'AutomaticReports.ReportLog';
        export const deletePermission = 'Reports:Setup';
        export const insertPermission = 'Reports:Setup';
        export const readPermission = 'Reports:Setup';
        export const updatePermission = 'Reports:Setup';

        export declare const enum Fields {
            Id = "Id",
            ReportId = "ReportId",
            Recipients = "Recipients",
            SendingDate = "SendingDate",
            Status = "Status"
        }
    }
}
